// src/TrainInfo.js
import React, { useState, useEffect } from 'react';
import dataCache from './services/dataCache';

const TrainInfo = () => {
  const [trainNo, setTrainNo] = useState('');
  const [trainInfo, setTrainInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchTrain = async () => {
    if (!trainNo) return;
    setLoading(true);
    setError(null);
    
    const cacheKey = `train_${trainNo}`;
    const fetchFunction = async () => {
      const response = await fetch(`https://train-query-backend.vercel.app/api/train/${trainNo}`);
      if (!response.ok) {
        throw new Error('查詢失敗');
      }
      return await response.json();
    };

    try {
      const data = await dataCache.getData(cacheKey, fetchFunction);
      if (data.TrainLiveBoards && data.TrainLiveBoards.length > 0) {
        setTrainInfo(data.TrainLiveBoards[0]);
      } else {
        setError('未查詢到資料');
      }
    } catch (err) {
      setError('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  };

  // 訂閱自動更新
  useEffect(() => {
    if (!trainNo) return;

    const cacheKey = `train_${trainNo}`;
    const unsubscribe = dataCache.subscribe(cacheKey, (updatedData) => {
      console.log('[TrainInfo] 收到自動更新資料');
      if (updatedData?.TrainLiveBoards && updatedData.TrainLiveBoards.length > 0) {
        setTrainInfo(updatedData.TrainLiveBoards[0]);
      }
    });

    return () => {
      unsubscribe();
      dataCache.stopAutoRefresh(cacheKey);
    };
  }, [trainNo]);

  return (
    <div className="train-info">
      {/*<h2>車輛動態查詢</h2>*/}
      <div className="search-container">
        <input 
          type="text" 
          value={trainNo} 
          onChange={(e) => setTrainNo(e.target.value)} 
          placeholder="請輸入車輛編號"
        />
        <button onClick={searchTrain} disabled={loading}>
          {loading ? '查詢中...' : '查詢'}
        </button>
      </div>
      {error && <div className="error">{error}</div>}
      {trainInfo && (
        <div className="result">
          <h2>列車資訊</h2>
          <div className="info-grid">
            <div className="info-item">
              <span className="label">車次：</span>
              <span className="value">{trainInfo.TrainNo}</span>
            </div>
            <div className="info-item">
              <span className="label">車種：</span>
              <span className="value">{trainInfo.TrainTypeName?.Zh_tw}</span>
            </div>
            <div className="info-item">
              <span className="label">目前站點：</span>
              <span className="value">{trainInfo.StationName?.Zh_tw}</span>
            </div>
            <div className="info-item">
              <span className="label">延誤時間：</span>
              <span className="value">{trainInfo.DelayTime} 分鐘</span>
            </div>
            <div className="info-item">
              <span className="label">更新時間：</span>
              <span className="value">{new Date(trainInfo.UpdateTime).toLocaleString()}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainInfo;
